
















































































































































































































































import Vue from 'vue';
import { State, Getter } from 'vuex-class';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import {
  FinancialInstitutionState,
  FinancialInstitution
} from '@/store/financial-institution/types';
import {
  ProductInformationState,
  ProductInformation
} from '@/store/product-information/types';
import {
	calculateInterest,
	calculateApyRate,
	calculateLowerBoundTier2ApyRate
} from '@/helpers/formula-helper';
const VMask = require('v-mask').default;
Vue.use(VMask);

const fiNamespace = 'financialInstitution';
const productNamespace = 'productInformation';

@Component({})
export default class LayoutFooter extends Vue {

	@Prop({required: true })
	applicationStep!: number;

	@State('financialInstitution')
	financialInstitution?: FinancialInstitutionState;

	@Getter('fiCompany', { namespace:fiNamespace })
	fiCompany?: FinancialInstitution;

	@State('productInformation')
	productInformation?: ProductInformationState;

	@Getter('product', { namespace:productNamespace })
	product?: ProductInformation;

	computed() {
		this.fiCompany;
		this.product;
	}

	getInsurance(companyName: string) {
        return companyName.toLowerCase().includes('bank') ? 'a Member FDIC.' : 'Federally Insured by NCUA.';
	}

	isEmpty(field: any) {
        return field && Object.keys(field).length === 0 && field.constructor === Object;
    }

	getInterest(rate: number, period: number){
		return calculateInterest(rate, period).toFixed(2);
	}

	getCurrentDate(){
		const currentDate = new Date();
		const day = String(currentDate.getDate()).padStart(2, '0');
		const year = currentDate.getFullYear();

		const months = [];
		months[0] = 'January';
		months[1] = 'February';
		months[2] = 'March';
		months[3] = 'April';
		months[4] = 'May';
		months[5] = 'June';
		months[6] = 'July';
		months[7] = 'August';
		months[8] = 'September';
		months[9] = 'October';
		months[10] = 'November';
		months[11] = 'December';
		const month = months[currentDate.getMonth()];

		return month + ' ' + day + ', ' + year;
	}

	getApyRate(rate: number){
		return calculateApyRate(rate).toFixed(2);
	}

	getLowerBoundTier2ApyRate(principal: string, rate: number, tier2Rate: number){
		const convertedPrincipal = parseInt(principal.replace(/,/g, ''));
		return calculateLowerBoundTier2ApyRate(convertedPrincipal, rate, tier2Rate).toFixed(2);
	}
}
